// extracted by mini-css-extract-plugin
export default {"intro-section-countdown-part-container":"IntroSection_intro-section-countdown-part-container__b1UM9"};